import React, { useEffect } from "react"

export const Section = ({ backgroundColor, children, name }) => {
  const handleScroll = () => {
    const section = document.getElementById("audiances")
    if (section) {
      const body = document.body
      const sectionTop = section.offsetTop
      const sectionHeight = section.offsetHeight
      const sectionBottom = sectionTop + sectionHeight
      const windowHeight = window.innerHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollBottom = scrollTop + windowHeight
      const sectionVisible =
        sectionTop < scrollBottom && sectionBottom > scrollTop
      if (sectionVisible) {
        const visibleSectionHeight = Math.min(
          sectionHeight,
          scrollBottom - sectionTop,
          windowHeight
        )
        const visiblePercent = (visibleSectionHeight / sectionHeight) * 100
        const bgColor = visiblePercent >= 50 ? backgroundColor : null
        body.style.backgroundColor = bgColor
      } else {
        body.style.backgroundColor = null
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  })

  return (
    <section className={name} id={name}>
      {children}
    </section>
  )
}
